import { GET_APPS_SUCCESS } from '../../../actions/api/apps/';
import { ADD_INTEGRATION_FAILURE } from '../../../actions/api/integration';
import {
  ADDINT_INITIALIZE,
  ADDINT_SAVE_CONNECTION,
  ADDINT_SELECT_APP,
  ADDINT_CHANGE_NAME
} from '../../../actions/page/admin/AddIntegration';

export default function AddIntegration(state = {}, action) {
  switch (action.type) {
    case ADDINT_INITIALIZE:
      const defaults = {
        selected: null,
        connectionName: '',
        connected: false,
        saving: false,
        error: false,
        isLoading: true
      };
      return {
        ...state,
        ...defaults
      };
    case ADDINT_SAVE_CONNECTION:
      return {
        ...state,
        connected: true,
        saving: true,
        error: false
      };
    case ADDINT_SELECT_APP:
      return {
        ...state,
        selected:
          state.selected && state.selected === action.appID
            ? null
            : action.appID
      };
    case ADDINT_CHANGE_NAME:
      return {
        ...state,
        connectionName: action.name
      };
    case GET_APPS_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    case ADD_INTEGRATION_FAILURE:
      return {
        ...state,
        saving: false,
        connected: false
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./js/reducers/page/admin/AddIntegration.js